// Test Url
export const Test_URL = `https://${process.env.REACT_APP_GRAPH_TEST_ID}.appsync-api.ap-northeast-1.amazonaws.com/graphql`;

// Dev Url
export const DEV_URL = `https://${process.env.REACT_APP_GRAPH_DEV_ID}.appsync-api.ap-northeast-1.amazonaws.com/graphql`;

// Production Url
export const API_URL = `https://${process.env.REACT_APP_GRAPH_API_ID}.appsync-api.ap-northeast-1.amazonaws.com/graphql`;
